import { service } from 'api';
import { cookies } from 'static';

const getToken = () => {
  const stored = localStorage.getItem(cookies.FarmersPlanToken);
  return stored ? JSON.parse(stored)?.token : undefined;
};

export type OrganisationFarmSummary = {
  id: number;
  farmName?: string;
  farmCode?: string;
  active?: boolean;
};

export type OrganisationCompany = {
  id: number;
  name?: string;
  companyRegistration?: string;
  companyType?: string;
  active?: boolean;
  farms?: OrganisationFarmSummary[];
};

export type OrganisationTree = {
  id: number;
  name?: string;
  customerNumber?: string;
  active?: boolean;
  memberRoleId?: number;
  memberRoleName?: string;
  canManage?: boolean;
  owned?: boolean;
  companies?: OrganisationCompany[];
  farms?: OrganisationFarmSummary[];
};

export type BillingCompany = {
  id: number;
  name?: string;
  companyRegistration?: string;
  companyType?: string;
  active?: boolean;
};

export const getUserBillingCompanies = (farmId?: string | number | null) =>
  service(
    '/api/v1/organisations/user-companies',
    {
      method: 'GET',
      params: farmId != null && String(farmId).trim() !== '' ? { farmId: String(farmId) } : undefined,
      suppressErrorToast: true,
    } as Parameters<typeof service>[1],
    getToken(),
  ) as Promise<BillingCompany[]>;

export const getUserOrganisationFarms = () =>
  service(
    '/api/v1/organisations/user-farms',
    { method: 'GET', suppressErrorToast: true } as Parameters<typeof service>[1],
    getToken(),
  ) as Promise<OrganisationFarmSummary[]>;

export const getUserOrganisations = () =>
  service(
    '/api/v1/organisations/user-all',
    { method: 'GET', suppressErrorToast: true } as Parameters<typeof service>[1],
    getToken(),
  ) as Promise<OrganisationTree[]>;

export const getOrganisation = (id: number | string) =>
  service(
    '/api/v1/organisations/get',
    { method: 'GET', params: { id: String(id) } },
    getToken(),
  ) as Promise<OrganisationTree>;

export const createOrganisation = (name: string) =>
  service('/api/v1/organisations/user-add', { method: 'POST', data: { name } }, getToken()) as Promise<{ id: number }>;

export const createCompany = (payload: {
  organisationId: string | number;
  name: string;
  companyRegistration: string;
  companyType: string;
}) =>
  service(
    '/api/v1/organisations/user-add-company',
    {
      method: 'POST',
      data: {
        organisationId: String(payload.organisationId),
        name: payload.name,
        companyRegistration: payload.companyRegistration,
        companyType: payload.companyType,
      },
    },
    getToken(),
  ) as Promise<{ id: number }>;
